import clsx from 'clsx';
import ToggleSwitch from 'components/inputs/toggle-switch';

type IncludeAllRecommendedToggleProps = {
  value: boolean;
  onChange: (include: boolean) => void;
  disabled?: boolean;
};

export default function IncludeAllRecommendedToggle({
  value,
  onChange,
  disabled = false
}: IncludeAllRecommendedToggleProps) {
  return (
    <div id='include-all-recommended' className='flex items-center gap-2 p-2'>
      <ToggleSwitch value={value} onChange={onChange} disabled={disabled} />
      <button
        type='button'
        className={clsx(
          'whitespace-nowrap text-sm text-gray-600',
          disabled && 'cursor-not-allowed opacity-70'
        )}
        onClick={() => onChange(!value)}
        disabled={disabled}
      >
        Include All Recommended Accessories
      </button>
    </div>
  );
}
